module.exports = __webpack_public_path__ + "static/keyboardist.afe22172.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/keyboardist.png
// module id = 752
// module chunks = 213720915766396